var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseTransitionGroup",
    {
      staticClass:
        "\n        fixed bottom-0 inset-x-0 p-4\n        flex flex-col items-end justify-center\n        pointer-events-none z-50\n    ",
      attrs: { tag: "aside", animations: "slide-up fade" }
    },
    _vm._l(_vm.$ui.snackbars, function(snackbar) {
      return _c("AppSnackbar", {
        key: snackbar.id,
        staticClass: "mb-2 last:mb-0",
        attrs: {
          id: snackbar.id,
          message: snackbar.message,
          options: snackbar.options
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }